<template>
  <component :is="currentComponent" />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'

export default defineComponent({
  name: 'AccountsWrapper',
  
  data() {
    return {
      ListAccounts: null,
      LocationsList: null
    }
  },

  computed: {
    ...mapGetters({
      isRevampEnabled: 'featureFlags/getForCompany'
    }),

    flagEnabled(): boolean {
      return this.isRevampEnabled('enable-97-297-ui-revamp')
    },

    currentComponent() {
      return this.flagEnabled ? this.LocationsList : this.ListAccounts
    }
  },

  async created() {
    // Dynamically import both components
    const [ListAccounts, LocationsList] = await Promise.all([
      import('@/pmd/pages/agency/ListAccounts.vue'),
      import('@/pmd/pages/LocationsList.vue')
    ])
    
    this.ListAccounts = ListAccounts.default
    this.LocationsList = LocationsList.default
  }
})
</script> 